<template lang="html">
  <div class="weather-forecast-slide">

    <div
      v-if="index">
      <p class="date">{{ day.day }}{{ day.code }}</p>
      <h1 class="status">
        <!-- <i class="icon" :class="icon" /> -->
        <span class="icon"><AtlasIcon :name="icon" /></span>
        <span class="temperature">{{ averageTemp }}</span>°
      </h1>
      <p class="description">{{ desc }}</p>
    </div>
    <div v-else>
      <p class="date">{{ u(weather.date, 'LLLL') }}</p>
      <h1 class="status">
        <span class="icon"><AtlasIcon :name="weather.aicon" /></span>
        <!-- <i class="icon" :class="weather.icon" /> -->
        <span class="temperature">{{ convertTemperature(weather.temp) }}</span>°
      </h1>
      <p class="description">{{ weather.desc }}</p>
    </div>

    <!-- <div class="temperature-minimum">
      min: {{ tempMin }}°
    </div>
    <div class="temperature-max">
      max: {{ tempMax }}°
    </div> -->

    <ChartLine
      v-if="chartLabels.length > 1"
      :height="120"
      :labels="chartLabels"
      :datasets="[
        {
          label: 'Temperature',
          backgroundColor: '#fff',
          borderColor: '#fff',
          data: chartTemps,
          datalabels: {
            color: '#fff',
            align: 'top'
          }
        } // ,
        /* {
          label: 'Humidité',
          backgroundColor: '#00BFFF',
          borderColor: '#00BFFF',
          data: chartHumidity,
          datalabels: {
            color: '#00BFFF',
            align: 'top'
          }
        } */
      ]"
      :options="{
        /* tooltips: {
          enabled: false
        }, */
        layout: {
          padding: {
            top: 20,
            left: 20,
            right: 20
          }
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: false
            /* gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#FFF'
            } */
          }],
          yAxes: [{
            display: false
          }]
        }
      }" />

    <ul class="status-list">
      <li
        v-for="i in day.forecast"
        :key="i.date">
        <span class="hour">{{ i.hour }}</span>
        <span class="icon"><i :class="i.icon" /></span>
        <span class="desc">{{ i.desc }}</span>
        <span class="wind">{{ convertWind(i.wind) }}<span class="kmh"> km/h </span><WindCompass color="#fff" :deg="i.windDeg" /></span>
      </li>
    </ul>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WindCompass from './WindCompass'
import mixinWeather from './mixins/weather'
export default {
  name: 'WeatherForecastSlide',
  mixins: [
    mixinWeather
  ],
  components: {
    WindCompass
  },
  props: {
    day: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  computed: {
    ...mapGetters({
      weather: 'map/weather'
    }),
    chartLabels () {
      return this.day.forecast.map(t => t.hour)
    },
    chartTemps () {
      return this.day.forecast.map(t => this.convertTemperature(t.temp))
    },
    // chartHumidity () {
    //   return this.day.forecast.map(t => t.humidity)
    // },
    averageTemp () {
      const total = this.chartTemps.reduce((total, temp) => {
        total += temp
        return total
      }, 0)
      return Math.round(total / this.chartTemps.length)
    },
    // tempSorted () {
    //   return [...this.chartTemps].sort()
    // },
    // tempMin () {
    //   return this.tempSorted[0]
    // },
    // tempMax () {
    //   return this.tempSorted[this.tempSorted.length - 1]
    // }
    icon () {
      return this.reduceAndSort(this.day.forecast, 'aicon')
    },
    code () {
      return this.reduceAndSort(this.day.forecast, 'code')
    },
    desc () {
      return this.reduceAndSort(this.day.forecast, 'desc')
    }
  },
  methods: {
    reduceAndSort (array, prop) {
      const allProps = array.reduce((dict, info) => {
        if (!dict[info[prop]]) dict[info[prop]] = 1
        else dict[info[prop]]++
        return dict
      }, {})
      const propsArray = Object.keys(allProps).map(prop => {
        return { prop, count: allProps[prop] }
      }).sort((a, b) => b.count - a.count)
      return propsArray[0].prop
    }
  }
}
</script>

<style lang="scss">
.weather-forecast-slide {
  text-align: center;
  color: white;
  .date {
    padding-top: 30px;
    font-size: 12px;
    font-weight: lighter;
  }
  .status {
    font-size: 40px;
    margin-bottom: 0;
    margin-top: 20px;
    .icon,
    .temperature {
      vertical-align: middle;
    }
    .temperature {
      margin-left: 10px;
    }
  }
  .description {
    margin-top: 0;
    font-size: 12px;
    font-weight: lighter;
  }
  .status-list {
    list-style: none;
    padding: 0 20px;
    margin: 0;
    text-align: left;
    font-size: 12px;
    li {
      position: relative;
      padding: 5px 0;
      border-bottom: dotted 1px rgba(white, .3);
      &:last-child {
        border: none;
      }
    }
    .hour {
      display: inline-block;
      width: 25px;
      color: rgba(white, .5);
    }
    .icon {
      display: inline-block;
      width: 30px;
      text-align: center;
    }
    .wind {
      position: absolute;
      right: 0;
      .wind-compass {
        vertical-align: text-top;
      }
    }
    .kmh {
      color: rgba(white, .5);
      font-size: 10px;
    }
  }
}
</style>
